import { useEffect, useState } from "react";
import axios from "axios";
import { Toaster, toast } from "sonner";
import PublicSite from "./PublicSite";
import LoqueAdmin from "@/admin/LoqueAdmin";
import LoqueLogin from "@/admin/LoqueLogin";
import LegalPage, { isLegalPath } from "./LegalPages";
import TourPage from "./TourPage";
import PropertyPage from "./PropertyPage";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "sehospedeaki_token";
const UNAUTH_EVENT = "sehospedeaki:unauth";

axios.interceptors.request.use((config) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});
axios.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && localStorage.getItem(TOKEN_KEY)) {
      localStorage.removeItem(TOKEN_KEY);
      window.dispatchEvent(new Event(UNAUTH_EVENT));
    }
    return Promise.reject(err);
  }
);

function AdminApp() {
  const [user, setUser] = useState(null); // null = checking, false = logged out

  useEffect(() => {
    localStorage.removeItem("blitzradar_token");
    const t = localStorage.getItem(TOKEN_KEY);
    if (!t) { setUser(false); return undefined; }
    axios.get(`${API}/auth/me`).then((r) => setUser(r.data)).catch(() => {
      localStorage.removeItem(TOKEN_KEY);
      setUser(false);
    });
    const onUnauth = () => setUser(false);
    window.addEventListener(UNAUTH_EVENT, onUnauth);
    return () => window.removeEventListener(UNAUTH_EVENT, onUnauth);
  }, []);

  const handleLogin = (u) => {
    setUser(u);
    toast.success("Bem-vindo ao painel.");
  };

  const handleLogout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setUser(false);
    toast("Sessão encerrada.");
  };

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FBF8F3]">
        <div className="text-[#0A66C2] font-bold animate-pulse" style={{ fontFamily: "Outfit, sans-serif" }}>
          Carregando Se Hospede AKI...
        </div>
      </div>
    );
  }

  return (
    <div translate="no">
      <Toaster position="top-right" richColors />
      {user === false ? (
        <LoqueLogin onLogin={handleLogin} tokenKey={TOKEN_KEY} />
      ) : (
        <LoqueAdmin user={user} onLogout={handleLogout} />
      )}
    </div>
  );
}

export default function App() {
  const path = window.location.pathname.replace(/\/$/, "");
  if (isLegalPath(path)) return <LegalPage path={path} />;
  if (path.startsWith("/admin")) return <AdminApp />;
  if (path.startsWith("/casa/")) return <PropertyPage id={decodeURIComponent(path.split("/")[2] || "")} />;
  if (path.startsWith("/passeio/")) return <TourPage id={decodeURIComponent(path.split("/")[2] || "")} />;
  return <PublicSite />;
}
